import React from "react";

import { TooltipDetails } from "../../../../types/row";
import css from "./side_panel_row_tooltip.module.scss";

type SidePanelRowTooltipContentProps = {
  tooltipDetails: TooltipDetails[];
};

export const SidePanelRowTooltipContent = ({
  tooltipDetails
}: SidePanelRowTooltipContentProps): JSX.Element => {
  const sortedTooltipDetails = tooltipDetails.sort(
    (tooltipDetailsA, tooltipDetailsB) => tooltipDetailsB.bookedHours - tooltipDetailsA.bookedHours
  );

  return (
    <div className={css.root}>
      {sortedTooltipDetails.map(({ categoryName, bookedHours }) => (
        <span key={`${categoryName}_${bookedHours}`}>{`${categoryName} ${bookedHours}h`}</span>
      ))}
    </div>
  );
};
